"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_unified__communications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "unified-communications-hi"), /*#__PURE__*/React.createElement("g", {
    id: "da001965-4718-41c3-986b-ea6890389dc3",
    "data-name": "unified-communications-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "73d0af12-bb22-4e10-a867-1e9cc95b07cf",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "52aae84a-a1fe-4bbe-8b01-fcd40705c0d8",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc4031f5-1c18-485e-bcb1-ea4cdaee20f7",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5f5d6c5b-62ae-4c77-895e-f17bad59d1b7",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2d72e191-ece4-498d-8eca-8c543bf24e2f",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "94aaee0b-0ab1-4f72-a679-d90c1870f516",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9c0a0f80-dfb6-4a02-a770-6acb31f745b9",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "29e90672-0fe4-4217-ab61-5773d7e24380",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a63247e7-7914-415a-8d5e-bbb1f74d56cb",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1c949b33-1658-4269-b776-0743fd0cb7d9",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8b233f96-7438-4dc5-a5ed-fef99bc702ad",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "52e02c9f-aaf9-4524-84d7-ef8a11e34818",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7d178ea8-b747-46f8-9ed3-b76bd50ee1fd",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a174f82-a462-4e8d-8c6a-56d15651227c",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dfc960d0-4df0-4aec-a03d-9d3643c9692e",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b23a830f-aa22-4524-b4d6-afb277beb16d",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7d9eb63b-0f78-46ea-992b-c16d4f86f747",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1e825559-bad3-4a57-916c-030d5bdb6f68",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0ab5a91-bd47-4bcd-8456-5bd4bae7b3e6",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e653d3fd-2cc0-45b1-a254-7c8fa093ee34",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7814300f-3262-49ad-ad3a-b2b61703afb7",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1f42133-0567-4969-a44a-305312963b54",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "47e14777-8865-4160-b3d4-6a89d99997f7",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13674dc5-e23b-4c31-9b45-002a12255e66",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "64338f50-04b6-40fe-8bc2-706ad2669060",
    "data-name": "Public_sector_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eec4f8a5-8913-422b-bf54-6b96607857cc",
    "data-name": "Extras_services_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "41adcd32-11f7-4dfa-88da-afe7ff156acc",
    "data-name": "Deal_Partnership_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "9fc9a4d5-22d8-4463-ac5d-5671178c8295",
    "data-name": "<Pfad>",
    d: "M77.34,129.54l13-5c3.24-.64,6.25-.18,7.71,1.38,2.2,2.36,20.29,23.32,21.8,25.15s1.31,5.77-2.36,8.64-19.86,13.71-24.87,12.11-25.94-8.09-54.09-58.15S16,43,17.35,38,36.77,25.59,41.23,24.13s8,.57,8.75,2.72c.89,2.45,9.14,28.46,10,31.42.6,2-.65,4.75-3,7.06s-11.56,11-11.56,11,2.18,8.44,12.58,26.92C63,112.2,77.34,129.54,77.34,129.54Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.47,74.35s.13.51.48,1.55c1.92-1.8,9.1-8.56,11.08-10.57,2.27-2.27,3.51-4.95,3-7a10.49,10.49,0,0,1-3,5C54.75,65.65,45.47,74.35,45.47,74.35Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.49,157.73c-3.67,2.86-19.86,13.71-24.87,12.11s-25.94-8.09-54.09-58.16C20.22,79.13,16.22,59,16,47.57c-.23,11.05,3.1,31.59,22.52,66.12,28.15,50.06,49.07,56.55,54.09,58.15s21.2-9.25,24.87-12.11c2.74-2.14,3.53-4.88,3.14-6.89A8,8,0,0,1,117.49,157.73Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.34,129.54h0l-.22-.23Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.46,73.54c-2.54-8.22-9.85-31.27-14.75-46.43-1.08.48-2.21,1-3.34,1.53C35.7,45.17,43.8,70.74,45.5,76.33Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.14,129.29l-.11-.13h0Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,128.14l-3.63,1.39c3.82,4.17,18.53,21.14,31.39,36.06,1.08-.66,2.13-1.32,3.11-2C99.77,149.62,86,133.66,81,128.14Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1401bc6-465a-432e-8c96-0d6c4895c2f1",
    "data-name": "<Pfad>",
    d: "M161.49,50.55s.2-1.06.26-1.42c1.14-7-3.51-13.72-3.51-13.72A36.11,36.11,0,0,0,148,24.61a46.74,46.74,0,0,0-14.76-6.79,55.26,55.26,0,0,0-17.75-1.72A55.93,55.93,0,0,0,98,20a48.24,48.24,0,0,0-14,8.58,37.5,37.5,0,0,0-9.13,12A29.77,29.77,0,0,0,72,54.79a28.72,28.72,0,0,0,1.92,9,31.37,31.37,0,0,0,4.57,8,37,37,0,0,0,6.83,6.67c2.61,2,8.06,4.38,11.22,5.79a34.43,34.43,0,0,1-9.23,12.23,2,2,0,0,0,1.4,3.51A46,46,0,0,0,102.8,97.2s3.25-1.18,12.56-6.39l1.2-.67",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.57,82.22c-3.17-1.41-8.62-3.81-11.22-5.79a37,37,0,0,1-6.83-6.67,31.37,31.37,0,0,1-4.57-8,28.72,28.72,0,0,1-1.92-9c0-.13,0-.27,0-.4,0,.8,0,1.6,0,2.4a28.72,28.72,0,0,0,1.92,9,31.37,31.37,0,0,0,4.57,8,37,37,0,0,0,6.83,6.67c2.41,1.82,7.23,4,10.45,5.44C96.07,83.34,96.34,82.79,96.57,82.22Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.73,88.6l-.37.2C106.05,94,102.8,95.2,102.8,95.2a46,46,0,0,1-8.12,2.15,46.44,46.44,0,0,1-5.93.61,2,2,0,0,1-1.81-1,2,2,0,0,0,1.81,3A46,46,0,0,0,102.8,97.2s3.25-1.18,12.56-6.39l1.2-.67h0C116.27,89.63,116,89.12,115.73,88.6Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "5525c5db-7e3c-46da-b96e-80639addf722",
    "data-name": "<Pfad>",
    d: "M162.75,50.92l-1.64-.49a43,43,0,0,0-13.87-1.35,43.57,43.57,0,0,0-13.65,3.07,37.68,37.68,0,0,0-10.94,6.73,29.41,29.41,0,0,0-7.13,9.42,23.43,23.43,0,0,0-2.24,11.12,23,23,0,0,0,3.32,10.78,28.28,28.28,0,0,0,8,8.47A36.41,36.41,0,0,0,136.15,104,43,43,0,0,0,150,105.35l.45,0a38.78,38.78,0,0,0,4.94,2.91,37,37,0,0,0,6.49,2.48,35.27,35.27,0,0,0,7.92,1.25,35.73,35.73,0,0,0,4.15-.06,2,2,0,0,0,1.11-3.54c-2.71-2.22-5.83-5.48-6-8.79a35.58,35.58,0,0,0,6.36-4.83,30.16,30.16,0,0,0,4.79-5.87,25.43,25.43,0,0,0,2.93-6.66,22.85,22.85,0,0,0-2.52-18,27,27,0,0,0-4.88-5.94,45.58,45.58,0,0,0-13-7.36",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,109.9a35.72,35.72,0,0,1-4.15.06,35.26,35.26,0,0,1-7.92-1.25,37,37,0,0,1-6.49-2.48,38.74,38.74,0,0,1-4.94-2.91l-.45,0A43,43,0,0,1,136.15,102a36.4,36.4,0,0,1-11.53-5.32,28.28,28.28,0,0,1-8-8.47,23,23,0,0,1-3.32-10.78h0c0,.67,0,1.33,0,2a23,23,0,0,0,3.32,10.78,28.28,28.28,0,0,0,8,8.47A36.42,36.42,0,0,0,136.15,104,43,43,0,0,0,150,105.35l.45,0a38.76,38.76,0,0,0,4.94,2.91,37,37,0,0,0,6.49,2.48,35.29,35.29,0,0,0,7.92,1.25,35.78,35.78,0,0,0,4.15-.06,2,2,0,0,0,1.57-3A1.92,1.92,0,0,1,174,109.9Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.18,80.21a25.44,25.44,0,0,1-2.93,6.66,30.16,30.16,0,0,1-4.79,5.87,35.59,35.59,0,0,1-6.36,4.83,6.44,6.44,0,0,0,.35,1.78,35.44,35.44,0,0,0,6-4.6,30.15,30.15,0,0,0,4.79-5.87,25.44,25.44,0,0,0,2.93-6.66,22.93,22.93,0,0,0,.8-7.15A23.06,23.06,0,0,1,183.18,80.21Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }))))))))))))))))))))))))))))));
}

var _default = ic_unified__communications;
exports.default = _default;